import React from "react";
import { Drawer, Space, Spin } from "antd";
import { CloseOutlined, LoadingOutlined } from "@ant-design/icons";

const MenuDrawer = ({
  visible,
  selectedMenu,
  title,
  drawerVisibility,
  children,
}) => {
  return (
    <Drawer
      title={selectedMenu ? "Edit Menu" : "New Menu"}
      placement="right"
      onClose={drawerVisibility}
      open={visible}
      width={500}
    >
      <div className="flex items-center gap-4 mb-5">
        <Space>
          <CloseOutlined onClick={drawerVisibility} />
        </Space>
        <h2 className="text-2xl">{title}</h2>
      </div>
      <div className="new-menu-drawer">{children}</div>
    </Drawer>
  );
};

export default MenuDrawer;
